import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=27627c7d&scoped=true&lang=pug&"
import script from "./Data.vue?vue&type=script&lang=ts&"
export * from "./Data.vue?vue&type=script&lang=ts&"
import style0 from "./Data.vue?vue&type=style&index=0&id=27627c7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27627c7d",
  null
  
)

export default component.exports